import { useCallback, useEffect, useState } from 'react'
import { DsGmeetBot, DsGmeetJob, getCall, getCallTranscript, MasterTranscriptSegment, requeueCall as apiRequeue, skipCall as apiSkip } from '../api/dsGmeetApi'

export function useDsGmeetBot(botId: string | undefined, currentUserId: string) {
    const [bot, setBot] = useState<DsGmeetBot | null>(null)
    const [activity, setActivity] = useState<DsGmeetJob[]>([])
    const [transcript, setTranscript] = useState<MasterTranscriptSegment[] | null>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const refetch = useCallback(async () => {
        if (!botId) return
        setLoading(true)
        setError('')
        try {
            const detail = await getCall(botId)
            setBot(detail.bot)
            setActivity(detail.activity)
            try {
                const segs = await getCallTranscript(botId)
                setTranscript(segs)
            } catch {
                setTranscript(null)
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : String(err))
        } finally {
            setLoading(false)
        }
    }, [botId])

    useEffect(() => {
        void refetch()
    }, [refetch])

    const requeue = useCallback(async () => {
        if (!botId) return
        await apiRequeue(botId, currentUserId)
        await refetch()
    }, [botId, currentUserId, refetch])

    const skip = useCallback(async () => {
        if (!botId) return
        await apiSkip(botId)
        await refetch()
    }, [botId, refetch])

    return { bot, activity, transcript, loading, error, refetch, requeue, skip }
}
